type ProposalForJobSizeValidation = {
  stages?: Array<{
    name?: string | null;
    proposalProducts?: Array<{
      jobSize?: number | null;
      productName?: string | null;
      externalProductName?: string | null;
      isOptional?: boolean | null;
      material?: {
        name?: string | null;
      } | null;
    } | null> | null;
  } | null> | null;
};

export const validateCurrency = (input: string): boolean => {
  const trimmed = input.trim();
  if (trimmed === "") return true; // Empty is valid (clears override)
  const numericPattern = /^(\d+(\.\d*)?|\.\d+)$/;
  if (!numericPattern.test(trimmed)) return false;
  const parsed = Number(trimmed);
  return !isNaN(parsed) && isFinite(parsed) && parsed >= 0;
};

export const validateInteger = (input: string): boolean => {
  const trimmed = input.trim();
  if (trimmed === "") return true;
  return /^\d+$/.test(trimmed);
};

export const validatePercentage = (input: string): boolean => {
  const trimmed = input.trim();
  if (trimmed === "") return true; // Empty is valid (clears override)
  const numericPattern = /^(\d+(\.\d*)?|\.\d+)$/;
  if (!numericPattern.test(trimmed)) return false;
  const parsed = Number(trimmed);
  return !isNaN(parsed) && isFinite(parsed) && parsed >= 0 && parsed <= 100;
};

export const getMissingJobSizeMessage = (
  proposal?: ProposalForJobSizeValidation | null
): string | null => {
  if (!proposal?.stages?.length) return null;

  for (const stage of proposal.stages) {
    const stageName = stage?.name?.trim() || "Untitled Job";
    const products = stage?.proposalProducts ?? [];
    for (const product of products) {
      if (!product) continue;
      const jobSize = product.jobSize ?? 0;
      if (jobSize > 0) continue;

      const productName =
        product.productName?.trim() ||
        product.externalProductName?.trim() ||
        product.material?.name?.trim() ||
        "Product";
      const label = product.isOptional ? "Option" : "Product";
      return `${label} - ${productName} in job ${stageName} is empty. Please input a job size.`;
    }
  }

  return null;
};
